import { AnalyticsProduct } from "utils/analytics/analytics.utils";
import { fromCents } from "utils/price.utils";

import { TrackOrderFragment } from "../track-swap.query.generated";

export const fromOrderItem = ({
  buyingPriceInCents,
  taxAmountInCents,
  item,
}: TrackOrderFragment["orderItems"][number]): AnalyticsProduct => ({
  product_id: String(item.id),
  sku: item.sku,
  category: item.itemType,
  name: item.name,
  brand: item.properties.brand,
  price: fromCents(buyingPriceInCents + (taxAmountInCents || 0)),
  currency: "EUR",
});
